import { render, staticRenderFns } from "./EarnedPointsBalance.vue?vue&type=template&id=7af26de4&scoped=true&"
import script from "./EarnedPointsBalance.vue?vue&type=script&lang=js&"
export * from "./EarnedPointsBalance.vue?vue&type=script&lang=js&"
import style0 from "./EarnedPointsBalance.vue?vue&type=style&index=0&id=7af26de4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af26de4",
  null
  
)

export default component.exports